const Truncation = {
    ELLIPSIS: 'ellipsis',
    BREAK_WORD: 'break_word'
};

export default Truncation;
